// Analytics session recording masks whatever sits inside `ph-no-capture`: a taster's notes and
// tasting history never leave the device through it. Screens wrap such content in NoCapture.
import "./config";
import { Column, type ColumnProps } from "./layout";

/** A Column whose content analytics recording must never read (tasting notes, the journal). */
export function NoCapture({ children, ...rest }: ColumnProps): React.JSX.Element {
  return (
    // nosemgrep: rules.typescript.react.best-practice.react-props-spreading -- props are typed as the component's own
    <Column className="ph-no-capture" {...rest}>
      {children}
    </Column>
  );
}
